<div class="row" [formGroup]="form" *ngIf="caseIsLDC">
  <div
    class="col-12 margTop"
    [ngClass]="userService.isRas ? 'contentRasSelectorForms' : ''"
  >
    <mat-form-field appearance="outline">
      <mat-label>Tipo de Alerta *</mat-label>
      <mat-select
        formControlName="tipo_de_riesgo"
        placeholder="Tipo de riesgo "
      >
        <mat-option
          *ngFor="let type of riskTypes"
          [matTooltip]="type"
          [value]="type"
        >
          {{ type }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div
    class="col-6 margTop"
    [ngClass]="userService.isRas ? 'contentRasSelectorForms' : ''"
  >
    <mat-form-field appearance="outline">
      <mat-label>Institución Reportante *</mat-label>
      <input matInput formControlName="institucion_reportante" type="text" />
    </mat-form-field>
  </div>

  <div
    class="col-6 margTop"
    [ngClass]="userService.isRas ? 'contentRasSelectorForms' : ''"
  >
    <mat-form-field appearance="outline">
      <mat-label>Identificación del Reportante *</mat-label>
      <input
        matInput
        formControlName="identificacion_del_reportante"
        type="text"
      />
    </mat-form-field>
  </div>

  <div
    [ngClass]="userService.isRas ? 'contentRasSelectorForms' : ''"
    class="col-4 margTop"
  >
    <mat-form-field appearance="outline">
      <mat-label>Fecha del Reporte *</mat-label>
      <input
        matInput
        formControlName="fecha_del_reporte"
        [matDatepicker]="picker2"
      />
      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
      <mat-datepicker #picker2></mat-datepicker>
    </mat-form-field>
  </div>

  <div
    [ngClass]="userService.isRas ? 'contentRasSelectorForms' : ''"
    class="col-4 margTop"
  >
    <mat-form-field appearance="outline">
      <mat-label>Tipo de persona *</mat-label>
      <mat-select
        (ngModelChange)="changeCi()"
        formControlName="tipo_de_persona"
        placeholder="Natural"
      >
        <mat-option *ngFor="let person of typeOfPerson" [value]="person">
          {{ person }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div
    [ngClass]="userService.isRas ? 'contentRasSelectorForms' : ''"
    class="col-4 margTop"
  >
    <mat-form-field appearance="outline">
      <mat-label>Número de Identificación *</mat-label>
      <input
        matInput
        formControlName="numero_de_identificacion"
        (keyup)="changeCi()"
        type="text"
      />
    </mat-form-field>
  </div>

  <div
    class="col-6 margTop"
    [ngClass]="userService.isRas ? 'contentRasSelectorForms' : ''"
  >
    <mat-form-field
      *ngIf="
        form.value.tipo_de_persona == 'J' ||
        form.value.tipo_de_persona == 'G' ||
        form.value.tipo_de_persona == 'I' ||
        form.value.tipo_de_persona == 'R' ||
        form.value.tipo_de_persona == ''
      "
      appearance="outline"
    >
      <mat-label>Nivel Socioeconómico *</mat-label>
      <mat-select formControlName="levelEcon" placeholder="Seleccionar nivel">
        <mat-option *ngFor="let level of levelSEconJur" [value]="level">
          {{ level }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field
      *ngIf="
        form.value.tipo_de_persona == 'P' ||
        form.value.tipo_de_persona == 'V' ||
        form.value.tipo_de_persona == 'E'
      "
      appearance="outline"
    >
      <mat-label>Nivel Socioeconómico *</mat-label>
      <mat-select formControlName="levelEcon" placeholder="Seleccionar nivel">
        <mat-option *ngFor="let level of levelSEconNatu" [value]="level">
          {{ level }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- <div class="col-6 margTop"  [ngClass]="userService.isRas ? 'contentRasSelectorForms' : ''">
    <mat-form-field appearance="outline">
      <mat-label>Región de la alerta *</mat-label>
      <mat-select formControlName="region_de_la_alerta" placeholder="Region 1">
        <mat-option *ngFor="let region of regions" [value]="region">
          {{ region }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div> -->

  <div
    class="col-6 margTop"
    [ngClass]="userService.isRas ? 'contentRasSelectorForms' : ''"
  >
    <mat-form-field appearance="outline">
      <mat-label>Nivel de riesgo *</mat-label>
      <mat-select
        placeholder="Nivel de riesgo"
        formControlName="nivel_de_riesgo"
      >
        <mat-option *ngFor="let level of riskLevels" [value]="level.name">
          {{ level.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
